/**
 * Toast wrapper - يستخدم الشريط البرتقالي الجديد
 * بديل لـ sonner toast
 */
import { showNotification } from './AnimatedNotificationBar';

export const toast = {
  success: (message, options = {}) => {
    showNotification(message, { type: 'success', ...options });
  },
  
  error: (message, options = {}) => {
    showNotification(message, { type: 'error', ...options });
  },
  
  warning: (message, options = {}) => {
    showNotification(message, { type: 'warning', ...options });
  },
  
  info: (message, options = {}) => {
    showNotification(message, { type: 'info', ...options });
  },
  
  // إشعار الأعضاء الجدد
  members: (memberCount, newMembersCount, options = {}) => {
    showNotification('', { 
      type: 'members',
      memberCount,
      newMembersCount,
      duration: 5000, // 5 ثوانٍ
      ...options 
    });
  },
  
  // Default toast call
  message: (message, options = {}) => {
    showNotification(message, { type: 'info', ...options });
  }
};

// Also export as default for compatibility
export default toast;
